module.exports = __webpack_public_path__ + "static/media/baggages-past.ad289e94.svg";